// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rotation-input-container {
    margin-top: 10px;
    margin-left: 5px;
    z-index: 10;
    max-width: 400px;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, .6);
    background: linear-gradient(to top, #eaeaea, #f3f3f3);
    flex-direction: column;
    width: 260px;
}

.rotation-input-container div {
    display: flex;
    flex-direction: column;
}

@media (min-width: 145rem) {
    .rotation-input-container div {
        flex-direction: row;
    }
}

.rotation-input-container label {
    margin-bottom: 10px;
    margin-right: 10px;
    font-weight: bold;
    display: flex;
    align-items: center;
}

.rotation-input-container input[type="number"] {
    margin-left: 10px;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 80px;
}

.rotation-input-container button {
    margin-top: 20px;
    padding: 10px 20px;
    border: 1px solid #cccaca;
    border-radius: 4px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background-color: #ececec;
    color: #000000;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.rotation-input-container button:hover {
    background-color: #d5d5d5;
}

.rotation-input-container h4 {
    margin-top: 10px;
    color: #333;
}`, "",{"version":3,"sources":["webpack://./src/RotationInput.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,qDAAqD;IACrD,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf","sourcesContent":[".rotation-input-container {\n    margin-top: 10px;\n    margin-left: 5px;\n    z-index: 10;\n    max-width: 400px;\n    padding: 20px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, .6);\n    background: linear-gradient(to top, #eaeaea, #f3f3f3);\n    flex-direction: column;\n    width: 260px;\n}\n\n.rotation-input-container div {\n    display: flex;\n    flex-direction: column;\n}\n\n@media (min-width: 145rem) {\n    .rotation-input-container div {\n        flex-direction: row;\n    }\n}\n\n.rotation-input-container label {\n    margin-bottom: 10px;\n    margin-right: 10px;\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n}\n\n.rotation-input-container input[type=\"number\"] {\n    margin-left: 10px;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    width: 80px;\n}\n\n.rotation-input-container button {\n    margin-top: 20px;\n    padding: 10px 20px;\n    border: 1px solid #cccaca;\n    border-radius: 4px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    background-color: #ececec;\n    color: #000000;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.rotation-input-container button:hover {\n    background-color: #d5d5d5;\n}\n\n.rotation-input-container h4 {\n    margin-top: 10px;\n    color: #333;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
